import Photoswipe from "photoswipe";
import PropTypes from "prop-types";
import React, { cloneElement, Component } from "react";

import { isMobileDevice } from "../../utils/Utils";

const photoswipeOptions = {
    allowPanToNext: false,
    arrowEl: false,
    arrowKeys: false,
    captionEl: false,
    closeOnScroll: false,
    closeOnVerticalDrag: isMobileDevice(),
    counterEl: false,
    fullscreenEl: false,
    hideAnimationDuration: 0,
    history: false,
    preloaderEl: false,
    shareEl: false,
    showAnimationDuration: 0,
    zoomEl: false,
};

export default class ImageAttachmentOverlay extends Component {
    constructor() {
        super();

        this.image = undefined;
        this.photoswipe = undefined;
        this.wrapper = undefined;

        this.initPhotoswipe = this.initPhotoswipe.bind(this);
        this.onImageLoad = this.onImageLoad.bind(this);
        this.onPhotoswipeDoubleTap = this.onPhotoswipeDoubleTap.bind(this);
        this.onPhotoswipeTapClick = this.onPhotoswipeTapClick.bind(this);
    }

    componentDidMount() {
        this.image = new Image();
        this.image.onload = this.onImageLoad;
        this.image.src = this.props.src;
    }

    onImageLoad() {
        this.initPhotoswipe();
        this.props.onOpen();
    }

    onPhotoswipeDoubleTap(point) {
        const { currItem: currentItem } = this.photoswipe;

        if (this.photoswipe.getZoomLevel() !== currentItem.initialZoomLevel) {
            this.photoswipe.zoomTo(currentItem.initialZoomLevel, point, 333);
        } else {
            const nextZoomLevel = this.photoswipe.options.getDoubleTapZoom(false, currentItem);

            this.photoswipe.zoomTo(nextZoomLevel, point, 333);
        }
    }

    onPhotoswipeTapClick(event) {
        const { hasClass } = this.photoswipe.framework;
        const shouldCloseOnOverlayTapClick = hasClass(event.target, "pswp__item");
        const shouldToggleDesktopZoom =
            hasClass(event.target, "pswp__img") && event.detail && event.detail.pointerType === "mouse";

        if (shouldCloseOnOverlayTapClick) {
            this.photoswipe.close();
        }
        if (shouldToggleDesktopZoom) {
            this.photoswipe.toggleDesktopZoom(event.detail.releasePoint);
        }
    }

    initPhotoswipe() {
        const image = {
            h: this.image.height,
            src: this.props.src,
            w: this.image.width,
        };

        this.photoswipe = new Photoswipe(this.wrapper, false, [image], photoswipeOptions);
        this.photoswipe.init();
        this.photoswipe.listen("close", this.props.onClose);
        this.photoswipe.listen("doubleTap", this.onPhotoswipeDoubleTap);
        this.photoswipe.framework.bind(this.photoswipe.scrollWrap, "pswpTap", this.onPhotoswipeTapClick);
    }

    render() {
        return (
            <div
                aria-hidden="true"
                className="pswp"
                ref={ref => {
                    this.wrapper = ref;
                }}
                role="dialog"
                tabIndex="-1"
            >
                <div className="pswp__bg" />
                <div className="pswp__scroll-wrap">
                    <div className="pswp__container">
                        <div className="pswp__item" />
                        <div className="pswp__item" />
                        <div className="pswp__item" />
                    </div>
                </div>

                <div className="pswp__ui pswp__ui--hidden">
                    <div className="pswp__top-bar">{cloneElement(this.props.closeButton)}</div>
                </div>
            </div>
        );
    }
}

ImageAttachmentOverlay.propTypes = {
    closeButton: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    src: PropTypes.string.isRequired,
};
